<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/group/group-list' }">分组管理</el-breadcrumb-item>
          <el-breadcrumb-item >新建分组</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12>
        <div style="padding: 6px 6px 8px 6px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">新建分组信息</div>
            </div>
          </div>
          <el-form
            :model="form"
              label-width="100px"
              class="add-form"
              :rules="rules"
              ref="form">
              <el-form-item label="分组名称" prop="name" class="top">
                <el-input id="name" v-model="form.name" placeholder="" ></el-input>
              </el-form-item>
              <!-- <el-form-item label="分组编码" prop="group_code" class="top">
                <el-input v-model="form.group_code" placeholder="" ></el-input>
              </el-form-item> -->
              <el-form-item label="分组描述" prop="description" class="top">
                <el-input id="description" v-model="form.description" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="权限分配" prop="permissions" class="error">

                <!-- 设备 -->
                <span style="color: #00FFFF;">设备</span>
                <el-checkbox-group v-model="form.permissions" class="group-box">
                  <el-checkbox
                  v-for="equip in equipments"
                  :label="equip.code"
                  :key="equip.name"
                  >{{equip.name}}</el-checkbox>
                </el-checkbox-group>
                <div style="margin: 15px 0;"></div>

                <!-- 耗材 -->
                <span style="color: #00FFFF;">耗材</span>
                <el-checkbox-group v-model="form.permissions" class="group-box">
                  <el-checkbox v-for="cons in consumables" :label="cons.code" :key="cons.name">{{cons.name}}</el-checkbox>
                </el-checkbox-group>


                <div style="margin: 15px 0;"></div>
                <!-- 账号 -->
                <span style="color: #00FFFF;">账号</span>
                <el-checkbox-group v-model="form.permissions"  class="group-box">
                  <el-checkbox
                    v-for="user in users"
                    :label="user.code"
                    :key="user.name"
                    @change="changeCheckBox(user.code)"
                    >{{user.name}}</el-checkbox>
                </el-checkbox-group>

                <div style="margin: 15px 0;"></div>
                <!-- 分组 -->
                <span style="color: #00FFFF;">分组</span>
                <el-checkbox-group v-model="form.permissions" class="group-box">
                  <el-checkbox v-for="group in groups" :label="group.code" :key="group.name">{{group.name}}</el-checkbox>
                </el-checkbox-group>

                <div style="margin: 15px 0;"></div>
                <!-- 识别码 -->
                <span style="color: #00FFFF;">识别码</span>
                <el-checkbox-group v-model="form.permissions"  class="group-box">
                  <el-checkbox v-for="code in codes" :label="code.code" :key="code.name">{{code.name}}</el-checkbox>
                </el-checkbox-group>

                <div style="margin: 15px 0;"></div>
                <!-- 知识库 -->
                <span style="color: #00FFFF;">知识库</span>
                <el-checkbox-group v-model="form.permissions"  class="group-box">
                  <el-checkbox v-for="knowledge in knowledges" :label="knowledge.code" :key="knowledge.name">{{knowledge.name}}</el-checkbox>
                </el-checkbox-group>

                <div style="margin: 15px 0;"></div>
                <!-- 设置 -->
                <span style="color: #00FFFF;">系统设置</span>
                <el-checkbox-group v-model="form.permissions"  class="group-box">
                  <el-checkbox v-for="set in sets" :label="set.code" :key="set.name">{{set.name}}</el-checkbox>
                </el-checkbox-group>

                <div style="margin: 15px 0;"></div>
                <!-- 数据统计 -->
                <span style="color: #00FFFF;">数据统计</span>
                <el-checkbox-group v-model="form.permissions"  class="group-box">
                  <el-checkbox v-for="map in dataShow" :label="map.code" :key="map.name">{{map.name}}</el-checkbox>
                </el-checkbox-group>

              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button class="action-button" type="primary"  @click="submitForm('form')">立即保存</el-button>
                <el-button class="action-button" @click="resetForm('form')">重置</el-button>
              </el-form-item>
            </el-form>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  const equipmentList = [{'name':'注册设备','code':'equipment:create'},{'name':'注销设备','code':'equipment:delete'},{'name':'查看设备','code':'equipment:read'},{'name':'监控设备','code':'equipment:maintain'}];
  const consumablesList = [{'name':'耗材出入库','code':'consumable:create'},{'name':'查看耗材','code':'consumable:read'},{'name':'告警耗材','code':'consumable:alert'}];
  const userList = [{'name':'新增账号','code':'account:create'},{'name':'删除账号','code':'account:delete'},{'name':'查看所有账号','code':'account:read'},{'name':'查看部分账号','code':'account:readSeveral'}];
  const knowledgeList = [{'name':'上传知识库','code':'knowledge:create'},{'name':'删除知识库','code':'knowledge:delete'},{'name':'查看知识库','code':'knowledge:read'}];
  const codeList =  [{'name':'新增识别码','code':'typecode:create'},{'name':'删除识别码','code':'typecode:delete'},{'name':'查看识别码','code':'typecode:read'}];
  const groupList = [{'name':'新增分组','code':'accountgroup:create'},{'name':'删除分组','code':'accountgroup:delete'},{'name':'查看分组','code':'accountgroup:read'}];
  const dataMap = [{'name':"查看数据分析",'code':'statistics:map'}]

  // system:log
  const setList = [{'name':"管理访问控制",'code':'system:accesscontrol'},{'name':"查看日志",'code':'system:log'}]

  export default {
    data() {
      return {
        equipments: equipmentList,
        consumables: consumablesList,
        users: userList,
        groups: groupList,
        codes: codeList,
        knowledges: knowledgeList,
        dataShow:dataMap,
        sets:setList,
        form: {
          name: '',//分组名称
          description: '',//分组描述
          permissions: [],//分组权限
        },
        rules: {
          name: [{ required: true, message: '请输入分组名称', trigger: 'blur' }],
          permissions: [{ required: true, message: '请选择权限', trigger: 'blur' }],
        },
      }
    },
    methods: {
      changeCheckBox(code){
        var array = this.form.permissions;

        if(code == 'account:read'){
          array = array.filter(item => item != 'account:readSeveral')
        }else if(code == 'account:readSeveral'){
          array = array.filter(item => item != 'account:read')
          this.$message({
            message: '指定账号仅限于维护账号或销售账号',
            type: 'warning'
          });
        }

        this.form.permissions = array;
      },

      toAddGroup(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/accountgroup/add';
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:this.form
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'新建分组成功',
                type:'success'
              });
              this.resetForm('form');
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.toAddGroup();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      goBack(){
        this.$router.back()
      }
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }


    .equip-add{

      .add-form{
        padding: 25px 5px 25px 0px;

        // 选中前后的文字颜色
        .redbox .el-checkbox__input+.el-checkbox__label{
          color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #FF8400;
        }

        //选中前后的边框颜色
        .redbox.is-bordered{
          border-color: rgba(255, 255, 255, 0.5);
        }
        .redbox.is-bordered.is-checked{
          border-color: #FF8400;
        }

        // 选中前后对勾框的边框和背景色
        .redbox .el-checkbox__input .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #A5D5FF;
          background-color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #FF8400;
          background-color: #FF8400;
        }

        .group-box{
          border-radius: 5px;
          border: 1px #20478D solid;
          padding: 10px;
        }
      }

      .content-add-user{
        float: left;
        border-radius: 3px;
      }
      .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }
    }

    //表单验证错误提示偏移
    .top .el-form-item__error{
      margin-top: -14px;
    }

    .error .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 10px;
    position: absolute;
    top: 100%;
    left: 0;
    }

    .opt .el-select__caret{
      //清除默认的select选择框样式
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-right: 14px;//箭头位置
      // margin-top: 40px;
    }

    .opt.el-icon-arrow-up:before{
      content: '';
    }

    // 下拉框位置
    .el-select-dropdown el-popper{
      position: absolute!important;
      top: 240px !important;
      left: 30px !important;
    }

    .el-checkbox-button__inner{
      background-color: #00DEFF;
    }


    .el-checkedbox__input.is-checked.el-checkbox__label{
      color: #FFFFFF;
    }

    .el-checkedbox__input
    {
      background-color: #00DEFF;
      color: brown;
    }


  }
</style>



// WEBPACK FOOTER //
// src/view/manage/group/group-add.vue